import { LocationAccess } from './location.types';

export const GEOLOCATION_OPTIONS: PositionOptions = {
  timeout: 15000,
  maximumAge: 60000,
};

export const DEFAULT_POSITION = {
  access: LocationAccess.Denied,
  latitude: null,
  longitude: null,
};
